import { filterOutInactiveFilterGroups, getTotalNumberOfSelectedFilters } from "./filters";
import { CHICAGO_TZ, toChicagoDate } from "./eventDate.js";

export const eventFilterLabels = {
  // type: "Type", hidden until content model is updated
  audience: "Audience",
  topics: "Topic",
  addOns: "Add ons",
  location: "Location"
};

const simpleEventFilters = [/* "type", */ "audience", "topics"];

export const unmapFilterLabelToKey = (label) => {
  const entry = Object.entries(eventFilterLabels).find(([, value]) => value === label);
  return entry ? entry[0] : null;
};

export const collectFilterCategoriesFromItems = (allEventItems) => {
  const filtersByCategory = allEventItems.reduce((acc, event) => {
    // General fields to merge
    simpleEventFilters.forEach((field) => {
      if (acc[field]) {
        acc[field] = Array.from(new Set([...acc[field], event[field]])).filter(Boolean);
      } else {
        acc[field] = event[field] ? [event[field]] : [];
      }
    });

    // Special logic for addOns to merge arrays
    acc.addOns = Array.from(new Set([...(acc.addOns || []), ...(event.addOns || [])]));

    // Special logic for locations to merge by name
    const locationName = event.specificLocation?.fields.locationName || event.venue?.fields.name;

    if (locationName) {
      if (acc.location) {
        acc.location = Array.from(new Set([...acc.location, locationName]));
      } else {
        acc.location = [locationName];
      }
    }

    return acc;
  }, {});

  return Object.entries(filtersByCategory).reduce((remapped, [key, value]) => {
    const newKey = eventFilterLabels[key];
    if (newKey) {
      remapped[newKey] = value;
    }
    return remapped;
  }, {});
};

export const filterEvents = (events = [], activeFilterGroups = []) => {
  const numberOfCheckedOptions = getTotalNumberOfSelectedFilters(activeFilterGroups);

  if (numberOfCheckedOptions === 0) {
    return events;
  }

  return events.filter((result) => {
    return filterOutInactiveFilterGroups(activeFilterGroups).every((filterGroup) => {
      return filterGroup.bodyProps.options.some((option) => {
        let matchesFilter = false;
        const filterKey = unmapFilterLabelToKey(filterGroup.headline);

        if (simpleEventFilters?.includes(filterKey)) {
          matchesFilter = result[filterKey] === option.label;
        } else if (filterKey === "addOns") {
          matchesFilter = result[filterKey]?.includes(option.label);
        } else if (filterKey === "location") {
          const locationName =
            result.specificLocation?.fields.locationName || result.venue?.fields.name;
          matchesFilter = locationName === option.label;
        }

        return option.isChecked && matchesFilter;
      });
    });
  });
};

export const filterPastEvents = (events, referenceDate = null) => {
  let todayInChicago;

  if (referenceDate) {
    todayInChicago = toChicagoDate(referenceDate);
  } else {
    const now = new Date();
    todayInChicago = new Date(now.toLocaleString("en-US", { timeZone: CHICAGO_TZ }));
  }

  return events.filter((event) => {
    if (!event.start) {
      return false;
    }
    const eventStart = new Date(event.start);
    return eventStart >= todayInChicago;
  });
};

export const getActiveFilterLabel = (activeFilters = [], numActiveFilters) => {
  if (numActiveFilters === 1) {
    const firstFilter = filterOutInactiveFilterGroups(activeFilters)?.[0].bodyProps.options.find(
      (option) => option.isChecked
    );
    return firstFilter.label;
  } else if (numActiveFilters < 10) {
    return numActiveFilters;
  } else {
    return "9+";
  }
};
